module.exports = __webpack_public_path__ + "static/sixFeetLogo-115ae50d03f518933d0d3faa3ffd530b.png";